var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"average"},[_c('h1',[_vm._v("平均想定年収")]),_vm._v(" "),_c('AverageGraph')],1)}
var staticRenderFns = []

export { render, staticRenderFns }